$(function(){
  var $slide = $(".fv-slider")
    .slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      speed: 3000,
      autoplaySpeed: 4000,
      autoplay: true
    })
  });